module.exports = __webpack_public_path__ + "static/media/default-product-image.e46299bb.svg";